import { useState } from 'react';
import { Icon, IconButton } from '@tb/ui';
import { useT } from '../i18n/LocaleProvider';
import { openExternal } from '../telegram/telegram';

export interface CopyableUrlProps {
  url: string;
  label?: string;
  icon?: 'globe' | 'domain';
}

export function CopyableUrl({ url, label, icon = 'globe' }: CopyableUrlProps) {
  const t = useT();
  const [copied, setCopied] = useState(false);

  const shown = label ?? url.replace(/^https?:\/\//, '');

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {}
  };

  return (
    <div className="url-row">
      <Icon name={icon} size={16} className="url-row__icon" />

      <span className="url-row__text tb-truncate" title={url}>
        {shown}
      </span>

      {copied ? (
        <span className="url-row__copied">{t('site.copied')}</span>
      ) : (
        <IconButton icon="copy" label={t('site.copyLink')} onClick={() => void copy()} />
      )}

      <IconButton
        icon="open-external"
        label={t('site.openLink')}
        onClick={() => openExternal(url)}
      />
    </div>
  );
}
